import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { IDisclaimerService } from "@/services/backend/disclaimer/disclaimer.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class DisclaimerService implements IDisclaimerService {
  async getDisclaimerFile(): Promise<string | undefined> {
    const { response, error } = await handleResponse<string, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/disclaimer/base64`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
